// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tourist-shop-container[data-v-7f0ffa2e]{margin-top:49px;text-align:center;font-family:Roboto;font-size:12px;font-weight:400;line-height:14px;letter-spacing:0}.tourist-product-wrapper[data-v-7f0ffa2e]{display:flex;flex-direction:column;align-items:center;width:146px}.tourist-product-wrapper img[data-v-7f0ffa2e]{height:146px}.tourist-product-wrapper figcaption[data-v-7f0ffa2e]{margin-top:6px;max-width:146px;word-wrap:break-word;text-align:center}", ""]);
// Exports
module.exports = exports;
